<template>
    <div class="liveBroad">
        <div class="hotContent" v-if="hot">
            <h2>热点直播</h2>
            <div class="liveBlock">
            <a href="javascript: void(0)" class="sensors_hot" @click="turnTo(hot)"><img :src="hot.adUrl" :alt="hot.title"></a>
            <a href="javascript: void(0)" class="sensors_hot" @click="turnTo(hot)">
                <p>{{ hot.title }}</p>
            </a>
            </div>
        </div>
        <div class="content" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
            <h2>往期回顾</h2>
            <dl class="item-content liveBlock" v-for="(item, index) in dataList" :key="index">
                <dt><a href="javascript: void(0)" class="sensors_hot" @click="turnTo(item)"><img :src="item.adUrl" /></a></dt>
                <dd><a href="javascript: void(0)" class="sensors_hot" @click="turnTo(item)">{{item.title}}</a></dd>
            </dl>
            <div v-if="dataList.length === 0 && !loading" class="no-data">
                <img src="../../../assets/images/normal/null_icon_data.png" alt="暂无数据"/>
                <p>
                    暂无数据
                </p>
            </div>

        </div>
    </div>
</template>

<script>
    import infiniteScroll from "vue-infinite-scroll";
    import {callHandler} from "../../../utils/bridge";
    export default {
        name: "liveBroad",
        data() {
            return {
                hot: {},
                dataList: [],
                busy: false,
                loading: true,
            };
        },
        directives: {infiniteScroll},
        created() {
            this.$request({
                url: "/h5/openClass/getTopOpenClassList"
            })
                .then(res => {
                    this.hot = res.data.topOpenClass;
                })
        },
        methods: {
            loadMore: (function () {
                let pageNo = 1, canRequest = true;
                return function () {
                    if(!canRequest) return false;
                    canRequest = false;
                    this.$request({
                        url: "/h5/openClass/getOpenClassList",
                        data: this.$qs.stringify({
                            pageNo
                        })
                    })
                        .then(res => {
                            canRequest = true;
                            this.loading = false;
                            if (res.data.length === 0) {
                                return (this.busy = true);
                            }
                            pageNo++;
                            this.dataList.push(...res.data.openClassList);
                        })
                        .catch(err => {
                            this.$toast(err);
                        });
                };
            })(),
            turnTo: function (obj) {
                let {classId,liveType,playUrl} = obj;
                /*
                如果是微吼，就直接跳转到微吼
                如果是星火直播，就跳原生
                * */
                if(liveType === 0){
                    // 跳直播原生
                    callHandler('xhOpenClassDetail',{
                        'classId': classId
                    })
                }else if(liveType === 1){
                    window.location.href = playUrl;
                }else{
                    this.$toast('接口返回参数错误');
                }
            }
        }
    };
</script>

<style lang="less">
    .liveBroad {
        padding: 12px 16px 16px 16px;
        h2 {
            font-size: 17px;
            font-weight: normal;
            color: #333;
            padding-bottom: 10px;
        }
        a {
            color: #666;
        }
        .liveBlock {
            border-radius: 8px;
            box-shadow: 0px 0px 8px #E2E2E2;
            padding-bottom: 12px;
            img {
                border-radius: 8px 8px 0 0;
            }
        }
        .no-data {
            height: 100vh;
            background: #FFFFFF;
            overflow: hidden;

            img {
                display: block;
                width: 120px;
                height: 120px;
                margin: 80px auto 20px;
            }

            p {
                font-size: 14px;
                color: #aaaaaa;
                text-align: center;
            }
        }
        .hotContent {
            font-size: 16px;
            img {
                width: 100%;
                display: inherit;
                margin-bottom: 12px;
            }
            p {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-size: 14px;
                color: #666;
                line-height: 20px;
                padding: 0px 12px;
            }
        }
        .content {
            background: #FFFFFF;
            padding: 12px 0;
            border-radius: 24px;
            margin-top: 5px;
        }

        .item-content {
            img {
                width: 100%;
                display: inherit;
            }
            margin-bottom: 12px;
            dt {
                margin-bottom: 12px;
            }
            dd {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-size: 14px;
                color: #666;
                line-height: 20px;
                padding: 0px 12px;
            }
        }
    }
</style>
